
export class InterestedFamilyPhotoModalController {

    private documentNo

    static $inject = ['$scope', '$uibModalInstance', 'InterestedHostFamiliesDetails', 'applicationId', 'documents', 'documentID']
    constructor(private $scope, private $uibModalInstance, private InterestedHostFamiliesDetails, private applicationId, private documents, documentID) {
        let index = this.documents.findIndex((d) => d.documentID == documentID);

        index = Math.min(index, this.documents.length - 1);
        index = Math.max(index, 0);

        this.loadPic(index);
    }
    prev() {
        let index = Math.max(this.documentNo - 1, 0); 
        this.loadPic(index);
    }

    next() {
        let index = Math.min(this.documentNo + 1, this.documents.length - 1);
        this.loadPic(index);
    }

    loadPic(index) {
        if (!this.documents[index].link) {
            this.InterestedHostFamiliesDetails.document({ applicationId: this.applicationId, documentId: this.documents[index].documentID }, (data) => {
                this.documents[index].link = data.link;
                this.documentNo = index;
            })
        } else {
            this.documentNo = index;
        }
    }

    close() {
        this.$uibModalInstance.dismiss()
    }
}

angular
    .module('app')
    .controller('InterestedFamilyPhotoModalController', InterestedFamilyPhotoModalController)
